export async function fetchCommissions({ commit }, params) {
  try {
    const commissions = (await this.$axios('/api/configs/commissions', { params })).data;
    commit('setCommissions', commissions);
  } catch {
    commit('setCommissions', {});
  }
}
export default {
  fetchCommissions,
};
